import { useMemo } from "react";

import { DefaultTable } from "twyne-new.ui";

import { formatDateTime } from "utils";

import DeleteFormatter from "./DeleteFormatter";
import EditFormatter from "./EditFormatter";
import Pagination from "./Pagination";

export default function Table({ loading, versions = [], version, onEdit, onDelete, onDefault, onNextPage }) {
  const data = useMemo(() => [{ id: '--', description: 'default', isDefault: true }, ...versions].sort((a, b) => a.id - b.id), [versions])

  const columns = useMemo(() => [{
    dataField: "id",
    text: "Id",
  }, {
    dataField: "description",
    text: "Description",
    formatter: descriptionFormatter,
  }, {
    dataField: "slug",
    text: "Slug",
    formatter: cell => cell || "--",
  }, {
    text: "",
    dataField: "action",
    className: "w-[80px]",
    formatter: actionsFormatter({ loading, version, onEdit, onDelete, onDefault }),
  }], [loading, version, onEdit, onDelete, onDefault])

  return <>
    <DefaultTable keyField="id" columns={columns} data={data}
      noDataIndication={() => "No versions yet."} />
    <Pagination onNextPage={onNextPage} />
  </>
}

const descriptionFormatter = (cell, row) => {
  const { updatedAt, isDefault } = row

  if (isDefault) {
    cell = "default"
  }

  return <>
    <div>{cell}</div>
    {<small style={{ color: "rgb(179, 184, 187)" }}>
      {formatDateTime(updatedAt)}
    </small>}
  </>
}

const actionsFormatter = ({ ...props }) => (cell, row) => {
  const { id, isDefault } = row
  const { loading, version, onEdit, onDelete, onDefault } = props
  const isEditing = (isDefault && !version) || version?.id === id

  return <div className="flex gap-2 pl-4">
    <EditFormatter loading={loading} data={row} isEditing={isEditing} isDefault={isDefault} onEdit={onEdit} onDefault={onDefault} />
    <DeleteFormatter data={row} isEditing={isEditing} isDefault={isDefault} onDelete={onDelete} />
  </div>
}
